import { render, staticRenderFns } from "./questionPaperPop.vue?vue&type=template&id=114478bf&scoped=true"
import script from "./questionPaperPop.vue?vue&type=script&lang=js"
export * from "./questionPaperPop.vue?vue&type=script&lang=js"
import style0 from "./questionPaperPop.vue?vue&type=style&index=0&id=114478bf&prod&lang=less"
import style1 from "./questionPaperPop.vue?vue&type=style&index=1&id=114478bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114478bf",
  null
  
)

export default component.exports